var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposalList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.297 0.0982666H4.6486C2.14677 0.0982666 0.118652 2.15495 0.118652 4.69202V16.5045C0.118652 19.0416 2.14677 21.0983 4.6486 21.0983H16.297C18.7989 21.0983 20.827 19.0416 20.827 16.5045V4.69202C20.827 2.15495 18.7989 0.0982666 16.297 0.0982666ZM19.5327 16.5045C19.5327 18.3167 18.0841 19.7858 16.297 19.7858H4.6486C2.86158 19.7858 1.41292 18.3167 1.41292 16.5045V4.69202C1.41292 2.87982 2.86158 1.41077 4.6486 1.41077H16.297C18.0841 1.41077 19.5327 2.87982 19.5327 4.69202V16.5045Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 4.69202H5.29557C4.93815 4.69202 4.64844 4.98581 4.64844 5.34827V6.66077C4.64844 7.02322 4.93815 7.31702 5.29557 7.31702H6.58984C6.94726 7.31702 7.23698 7.02322 7.23698 6.66077V5.34827C7.23698 4.98581 6.94726 4.69202 6.58984 4.69202Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 9.28577H5.29557C4.93815 9.28577 4.64844 9.57956 4.64844 9.94202V11.2545C4.64844 11.617 4.93815 11.9108 5.29557 11.9108H6.58984C6.94726 11.9108 7.23698 11.617 7.23698 11.2545V9.94202C7.23698 9.57956 6.94726 9.28577 6.58984 9.28577Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 13.8795H5.29557C4.93815 13.8795 4.64844 14.1733 4.64844 14.5358V15.8483C4.64844 16.2107 4.93815 16.5045 5.29557 16.5045H6.58984C6.94726 16.5045 7.23698 16.2107 7.23698 15.8483V14.5358C7.23698 14.1733 6.94726 13.8795 6.58984 13.8795Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2969 5.34814H8.53125V6.66064H16.2969V5.34814Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2969 9.94189H8.53125V11.2544H16.2969V9.94189Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2969 14.5358H8.53125V15.8483H16.2969V14.5358Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalList);
export default __webpack_public_path__ + "static/media/ProposalList.14c3a769.svg";
export { ForwardRef as ReactComponent };